import { ResponseError } from 'src/shared/types';

export const getAllLoginErrors = (response: ResponseError): string[] => {
    const errors: string[] = [];
    response?.error?.response?.data?.errors?.email?.forEach((item) => errors.push(item));
    response?.error?.response?.data?.errors?.user?.forEach((item) => errors.push(item));
    return errors;
};
